import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import {
    FolderServiceMailRecordsComponent,
} from '../folder-service-mail-records/folder-service-mail-records.component';
import { FolderGlobalStore } from '../../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../shared/shared.global-service';

@Component({
    selector: 'app-folder-service-mail-records-dialog',
    templateUrl: './folder-service-mail-records-dialog.component.html',
    styleUrl: './folder-service-mail-records-dialog.component.scss',
    imports: [
        FolderServiceMailRecordsComponent,
    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class FolderServiceMailRecordsDialogComponent extends BaseDialogComponent {

    private readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
